module.exports = __webpack_public_path__ + "static/media/drill-day-4.cbdce25e.png";